import { gql } from '__generated__';

export const TENANT_CONFIG = gql(/* GraphQL */ `
  fragment TenantConfig on Tenant {
    id
    name
    timezone
    dateFormat
    pillar1Name
    pillar2Name
    pillar3Name
    pillar4Name
    storeRef1Name
    storeRef2Name
    storeRef3Name
    storeStateName
    isSuperTenant
    emailAllowlist
    emailAllowlistEnabled
    userTagGroups {
      ...AdminTagGroup
    }
    storeTagGroups {
      id
      name
    }
    hiddenMediaCategoriesEnabled
    mobAppAccessEnabled
    mobAppClientId
    subtaskExpiryPeriod
  }
`);
